import ENUM_TYPES from '@components-shared/enum.types';
import { IApiCopyType, IApiGroupMappingType } from 'api/interfaces/data-contracts';

export const emptyInvestorWarnings = {
  showWarning: false,
  warningsInLanguages: {},
};

export const emptySelectedMasterAccount = {
  totalFundsInUsd: 0,
  avatar: '',
  profitSharing: 0,
  copyType: '' as IApiCopyType,
  countOfInvestors: 0,
  groupMappingType: '' as IApiGroupMappingType,
  tradingPlatformType: '' as ENUM_TYPES['TRADING_PLATFORM_TYPE'],
  isCopied: false,
  login: 0,
  masterAccountId: '',
  nickname: '',
  position: 0,
  profitability: 0,
  description: '',
  leverage: 0,
  userIdHash: '',
  tradingAccountIdHash: '',
  country: '',
  currency: '',
  initials: '',
  recommendedMinDepositAmount: null,
  investorTradingAccountTypeId: null,
};

export const emptySelectedInvestorAccount = {
  investorAccountType: {
    displayName: '',
    groupMappingType: '' as IApiGroupMappingType,
    id: 0,
    leverages: [],
    currency: '',
    tradingPlatformType: 'Meta4' as ENUM_TYPES['TRADING_PLATFORM_TYPE'],
  },
  investorLogin: 0,
  groupMappingType: '' as IApiGroupMappingType,
  id: 0,
  masterInfo: null,
  tradingAccountIdHash: '',
  tradingAccountDisplayName: '',
  tradingAccountName: null,
};
